var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
const mergeStyles = (style) => {
    if (!Array.isArray(style))
        return style;
    return style.reduce((acc, s) => (Object.assign(Object.assign({}, acc), s)), {});
};
export function View(_a) {
    var { style } = _a, props = __rest(_a, ["style"]);
    return _jsx("div", Object.assign({ style: mergeStyles(style) }, props));
}
export function Text(_a) {
    var { style } = _a, props = __rest(_a, ["style"]);
    return _jsx("div", Object.assign({ style: mergeStyles(style) }, props));
}
export function Document(_a) {
    var { style } = _a, props = __rest(_a, ["style"]);
    return _jsx("div", Object.assign({ style: mergeStyles([style, { width: '100%', flexGrow: 1 }]) }, props));
}
export function Page(_a) {
    var { style } = _a, props = __rest(_a, ["style"]);
    return _jsx("div", Object.assign({ style: mergeStyles([style, { paddingTop: '0px' }]) }, props));
}
